module.exports = __webpack_public_path__ + "activity2.e97c38be.png";